import React from "react";
import data from "../../data/brands/_shared/apex-feature-band.json";
import "./ApexFeatureBand.css";

/**
 * Apex feature-band: 4 icon-tiles + nomination ribbon.
 * Recreated from apexosn.com home elements:
 *   - data-id="4d03681" (4 icon-box features)
 *   - data-id="0939555" (IAOS nomination)
 * Rendered with our neumorphic styling.
 */
export default function ApexFeatureBand() {
  if (!data || !data.features || data.features.length === 0) return null;
  return (
    <section
      className="apex-feature-band section-padding"
      role="region"
      aria-label="Apex Orthopedic & Spine Network features"
    >
      <div className="container">
        <ul className="apex-feature-band__grid">
          {data.features.map((f, i) => (
            <li key={i} className="apex-feature-band__item">
              <span
                className="apex-feature-band__icon"
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: f.svg }}
              />
              <h3 className="apex-feature-band__title">{f.title}</h3>
            </li>
          ))}
        </ul>

        {data.nomination && (
          <div
            className="apex-feature-band__nomination"
            role="note"
            aria-label="Nomination"
          >
            <span
              className="apex-feature-band__nomination-icon"
              aria-hidden="true"
              dangerouslySetInnerHTML={{ __html: data.nomination.svg }}
            />
            <span className="apex-feature-band__nomination-text">
              {data.nomination.text}
            </span>
          </div>
        )}
      </div>
    </section>
  );
}
